<template>
  <v-col cols="3" class="pa-1" v-if="banner">
    <v-img :src="url + banner.file_name" v-if="banner"
           @click="window.location.href = banner.link"
           height="10em"
    />
  </v-col>
</template>

<script>
export default {
  name: 'BanerTile',
  props: ['banner'],
  data() {
    return {
      url: process.env.VUE_APP_URL,
    };
  },
};
</script>

<style scoped>

</style>
